import "moment/locale/id";
import { Route, Routes } from "react-router-dom";
import Loadable from 'react-loadable';
import PageLoader from "components/PageLoader";

const LazyReport = Loadable({
    loader: () => import("pages/Report/index"),
    loading: () => <PageLoader />,
});


function ReportRoute() {
    return (
        <Routes>
            <Route path="/" element={<LazyReport />} />
        </Routes>
    );
}

export default ReportRoute;
